export default __webpack_public_path__ + "video-a3f4be8.png";